import { createFileRoute } from "@tanstack/react-router"
import DesignSystemGraphs from "~/pages/design-system/Graphs"

export const Route = createFileRoute("/_auth/internal/design-system/graphs")({
  staticData: { skipSkuStoreData: true },
  component: RouteComponent,
})

function RouteComponent() {
  return <DesignSystemGraphs />
}
